import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";

export default class extends Controller {
  connect() {
    M.Tooltip.init(this.element, { enterDelay: 400 });
  }

  disconnect() {
    this.instance.destroy();
  }

  get instance() {
    return M.Tooltip.getInstance(this.element);
  }
}
